
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Games',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: 'Turn-based PvP for skins: gear up and outplay your rival',
    rushMidCta: 'Rush the mid',
    rouletteTitle: 'Russian Roulette',
    rouletteDescription: 'R8 cylinder, last one standing takes the bank',
    rouletteCta: 'Play',
    caseBattlesTitle: 'Case Battles',
    caseBattlesDescription: 'Test your luck against other players',
    contractsTitle: 'Contracts',
    contractsDescription: 'Exchange items for better ones',
    upgradeTitle: 'Upgrade',
    upgradeDescription: 'Upgrade items with a chance for rare skins',
    auctionsTitle: 'Auctions',
    auctionsDescription: 'Participate in auctions and win items',
    shopTitle: 'Shop',
    shopDescription: 'Buy items',
    comingSoon: 'Coming Soon',
    maintenanceBadge: 'Updating…',
    caseBattlesCta: 'Fight',
    contractsCta: 'Exchange',
    upgradeCta: 'Upgrade',
    shopCta: 'Open',
  },
  ru: {
    title: 'Игры',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: 'Пошаговый PvP за скины: закупись и переиграй соперника',
    rushMidCta: 'Зарашить мид',
    rouletteTitle: 'Русская рулетка',
    rouletteDescription: 'Барабан R8, выживший забирает банк',
    rouletteCta: 'Играть',
    caseBattlesTitle: 'Кейс Баттлы',
    caseBattlesDescription: 'Проверь удачу против других игроков',
    contractsTitle: 'Контракты',
    contractsDescription: 'Обменивай предметы на более ценные',
    upgradeTitle: 'Апгрейд',
    upgradeDescription: 'Улучшай предметы с шансом на редкие скины',
    auctionsTitle: 'Аукционы',
    auctionsDescription: 'Участвуй в аукционах и выигрывай предметы',
    shopTitle: 'Магазин',
    shopDescription: 'Покупай предметы',
    comingSoon: 'Скоро',
    maintenanceBadge: 'Обновление…',
    caseBattlesCta: 'В бой',
    contractsCta: 'Обменять',
    upgradeCta: 'Улучшить',
    shopCta: 'Открыть',
  },
  uz: {
    title: "O'yinlar",
    rushMidTitle: 'Rush Mid',
    rushMidDescription: "Skinlar uchun navbatma-navbat PvP: qurollan va raqibingni ort",
    rushMidCta: 'Midni rush qilish',
    rouletteTitle: 'Rus ruletkasi',
    rouletteDescription: "R8 barabani, omon qolgan bankni oladi",
    rouletteCta: "O'ynash",
    caseBattlesTitle: 'Keys Janglar',
    caseBattlesDescription: "Boshqa o'yinchilarga qarshi omadingizni sinab ko'ring",
    contractsTitle: 'Kontraktlar',
    contractsDescription: 'Buyumlarni qimmatroqlariga almashtiring',
    upgradeTitle: 'Yaxshilash',
    upgradeDescription: 'Buyumlarni kamyob skinlarga yaxshilash imkoniyati bilan',
    auctionsTitle: 'Auktsionlar',
    auctionsDescription: 'Auktsionlarda qatnashing va buyumlar yuting',
    shopTitle: "Do'kon",
    shopDescription: 'Buyumlarni sotib oling',
    comingSoon: 'Tez kunda',
    maintenanceBadge: 'Yangilanmoqda…',
    caseBattlesCta: 'Jang',
    contractsCta: 'Almashtirish',
    upgradeCta: 'Yaxshilash',
    shopCta: 'Ochish',
  },
});
